import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalsAltIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ApprovalsAlt",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.86 31.86c-.64 0-1.28-.24-1.77-.73l-3.15-3.15s-.1-.07-.16-.07H6.32a2.51 2.51 0 0 1-2.51-2.5v-4.46c0-.06-.02-.12-.07-.16L.59 17.64c-.98-.98-.98-2.57 0-3.54l3.15-3.15s.06-.1.06-.16V6.33c0-1.38 1.12-2.51 2.51-2.51h4.46c.06 0 .11-.02.16-.07L14.08.6c.95-.95 2.6-.95 3.54 0l3.15 3.15s.1.07.16.07h4.46c1.38 0 2.51 1.12 2.51 2.51v4.46c0 .06.02.11.06.16l3.15 3.15c.98.98.98 2.57 0 3.55l-3.15 3.15s-.07.1-.07.16v4.46c0 1.38-1.12 2.5-2.51 2.5h-4.46c-.06 0-.11.02-.16.07l-3.15 3.15c-.49.49-1.13.73-1.77.73ZM6.31 6.09c-.12 0-.22.1-.22.22v4.46c0 .67-.26 1.3-.73 1.77L2.2 15.7c-.09.09-.09.23 0 .31l3.15 3.15c.47.48.73 1.11.73 1.77v4.46c0 .12.1.22.22.22h4.46c.67 0 1.3.26 1.77.73l3.16 3.16c.09.09.23.09.31 0l3.15-3.15c.47-.47 1.1-.73 1.77-.73h4.46c.12 0 .22-.1.22-.22v-4.46c0-.67.26-1.3.73-1.77l3.15-3.15c.09-.09.09-.23 0-.31l-3.15-3.15c-.47-.47-.73-1.1-.73-1.77V6.33c0-.12-.1-.22-.22-.22h-4.46c-.67 0-1.3-.26-1.77-.73l-3.16-3.15c-.11-.11-.21-.11-.31 0l-3.15 3.15c-.47.47-1.1.73-1.77.73H6.3Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.3 21.21c-.3 0-.59-.12-.81-.33l-4.16-4.16a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.35 3.35 6.46-6.46a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-7.27 7.27c-.21.21-.5.33-.81.33"
    })]
  }));
};
ApprovalsAltIcon.displayName = 'ApprovalsAltIcon';